import {generateUUID} from "../misc";
import deviceInfo from "../deviceInfo/deviceInfo";
import {computerUuidRepository} from "../../repositories/device-info/computer-uuid-repository";
import {logger} from "../log/logger";


function generateComputerIdAndSaveToStorage(){
  const newComputerId = generateUUID();
  computerUuidRepository.set(newComputerId);
  return newComputerId;
}
export function getComputerId(){
  return computerUuidRepository.get() || generateComputerIdAndSaveToStorage();
}

export function getComputerType(){
  // return window.navigator.appVersion;
  const result = {
    userAgent: window.navigator.appVersion,
    os: deviceInfo.getBrowserInfo().name,
    version: deviceInfo.getBrowserInfo().version,
  };
  logger.device.debug({message: `computer type: ` + result});
  return JSON.stringify(result);
}
